import { loadAsyncImages } from "./utils";
const SCROLL_POSITION_TOGGLE_NAV_BAR = 50;

document.addEventListener('DOMContentLoaded', () => {
  const navBar = document.getElementById('nav-menu');
  loadAsyncImages(navBar);

  ScrollTrigger.create({
    end: 99999,
    onUpdate: (scroller) => {
      const scrollPosition = scroller.scroll();
      const scrollingDown = scroller.direction === 1;
      const scrollingUp = scroller.direction === -1
      
      if (scrollPosition <= SCROLL_POSITION_TOGGLE_NAV_BAR) {
        navBar.classList.add('in-top-range');            
      } else {
        navBar.classList.remove('in-top-range');            
      }

      if (scrollingDown) {
        navBar.classList.add('scroll-down');
        navBar.classList.remove('scroll-up');
      } else if (scrollingUp) {
        navBar.classList.add('scroll-up');
        navBar.classList.remove('scroll-down');
      }
    }
  });
});
